// ParallaxImageWithGSAP.jsx
import { useEffect, useRef } from "react";
import Lenis from "lenis";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function ParallaxImageWithGSAP({ speed = 0.5, ...imgProps }) {
  const imgRef = useRef(null);
  const wrapperRef = useRef(null);
  const startOffset = window.innerHeight * 0.15; 

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const el = imgRef.current;
    if (!wrapper || !el) return;

    // Initialize Lenis
    const lenis = new Lenis({ smooth: true });

    // Drive Lenis from GSAP's ticker so both tick together
    // GSAP ticker passes time in seconds; Lenis expects ms in raf(time)
    const tickerCallback = (time) => {
      // convert seconds -> milliseconds
      lenis.raf(time * 1000);
    };
    gsap.ticker.add(tickerCallback);

    // Keep ScrollTrigger in sync with Lenis scroll
    lenis.on("scroll", ScrollTrigger.update);

    // When ScrollTrigger refreshes (recalculates start/end), tick Lenis once
    // so any geometry that depends on the current scroll state is correct.
    const onRefresh = () => {
      // one RAF tick with current time to let Lenis update internal values
      lenis.raf(performance.now());
    };
    ScrollTrigger.addEventListener("refresh", onRefresh);

    // Basic parallax animation using GSAP ScrollTrigger
    // Using function-based y values so they adapt on refresh/resize
    gsap.fromTo(
      el,
      { y: () =>  -window.innerHeight/3* speed },
      {
        y: () =>window.innerHeight/3 * speed,
        ease: "none",
        scrollTrigger: {
          trigger: wrapper,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );

    // Force an initial refresh so ScrollTrigger calculates correctly
    ScrollTrigger.refresh();

    // Cleanup
    return () => {
      // remove ticker
      gsap.ticker.remove(tickerCallback);

      // remove listeners
      lenis.off("scroll", ScrollTrigger.update);
      ScrollTrigger.removeEventListener("refresh", onRefresh);

      // kill all ScrollTriggers attached to this element
      ScrollTrigger.getAll().forEach((st) => st.kill());

      // destroy Lenis instance
      lenis.destroy();
    };
  }, [speed]);

  // make wrapper a clipping container (styles can be overridden via imgProps.style)
  return (
    <div
      ref={wrapperRef}
   
    >
      <img
        ref={imgRef}
        {...imgProps}
       
      />
    </div>
  );
}
